// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "measurequick.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "measurequick.proto" (syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class GetHealthStatusRequest$Type extends MessageType {
    constructor() {
        super("GetHealthStatusRequest", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetHealthStatusRequest
 */
export const GetHealthStatusRequest = new GetHealthStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetHealthStatusResponse$Type extends MessageType {
    constructor() {
        super("GetHealthStatusResponse", [
            { no: 1, name: "reachable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "sandbox", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "partner_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "partner_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "company_connected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "mq_company_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "company_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "mapped_technicians", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "unmapped_technicians", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reachable = false;
        message.sandbox = false;
        message.partnerId = 0n;
        message.partnerName = "";
        message.companyConnected = false;
        message.mqCompanyId = 0n;
        message.companyName = "";
        message.mappedTechnicians = 0;
        message.unmappedTechnicians = 0;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool reachable */ 1:
                    message.reachable = reader.bool();
                    break;
                case /* bool sandbox */ 2:
                    message.sandbox = reader.bool();
                    break;
                case /* int64 partner_id */ 3:
                    message.partnerId = reader.int64().toBigInt();
                    break;
                case /* string partner_name */ 4:
                    message.partnerName = reader.string();
                    break;
                case /* bool company_connected */ 5:
                    message.companyConnected = reader.bool();
                    break;
                case /* int64 mq_company_id */ 6:
                    message.mqCompanyId = reader.int64().toBigInt();
                    break;
                case /* string company_name */ 7:
                    message.companyName = reader.string();
                    break;
                case /* int32 mapped_technicians */ 8:
                    message.mappedTechnicians = reader.int32();
                    break;
                case /* int32 unmapped_technicians */ 9:
                    message.unmappedTechnicians = reader.int32();
                    break;
                case /* string message */ 10:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool reachable = 1; */
        if (message.reachable !== false)
            writer.tag(1, WireType.Varint).bool(message.reachable);
        /* bool sandbox = 2; */
        if (message.sandbox !== false)
            writer.tag(2, WireType.Varint).bool(message.sandbox);
        /* int64 partner_id = 3; */
        if (message.partnerId !== 0n)
            writer.tag(3, WireType.Varint).int64(message.partnerId);
        /* string partner_name = 4; */
        if (message.partnerName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.partnerName);
        /* bool company_connected = 5; */
        if (message.companyConnected !== false)
            writer.tag(5, WireType.Varint).bool(message.companyConnected);
        /* int64 mq_company_id = 6; */
        if (message.mqCompanyId !== 0n)
            writer.tag(6, WireType.Varint).int64(message.mqCompanyId);
        /* string company_name = 7; */
        if (message.companyName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.companyName);
        /* int32 mapped_technicians = 8; */
        if (message.mappedTechnicians !== 0)
            writer.tag(8, WireType.Varint).int32(message.mappedTechnicians);
        /* int32 unmapped_technicians = 9; */
        if (message.unmappedTechnicians !== 0)
            writer.tag(9, WireType.Varint).int32(message.unmappedTechnicians);
        /* string message = 10; */
        if (message.message !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetHealthStatusResponse
 */
export const GetHealthStatusResponse = new GetHealthStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncTechniciansRequest$Type extends MessageType {
    constructor() {
        super("SyncTechniciansRequest", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SyncTechniciansRequest
 */
export const SyncTechniciansRequest = new SyncTechniciansRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SyncTechniciansResponse$Type extends MessageType {
    constructor() {
        super("SyncTechniciansResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "mq_company_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "mq_technicians", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "mapped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "unmatched_mq", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "unmapped_kalos", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        message.mqCompanyId = 0n;
        message.mqTechnicians = 0;
        message.mapped = 0;
        message.unmatchedMq = 0;
        message.unmappedKalos = 0;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* int64 mq_company_id */ 2:
                    message.mqCompanyId = reader.int64().toBigInt();
                    break;
                case /* int32 mq_technicians */ 3:
                    message.mqTechnicians = reader.int32();
                    break;
                case /* int32 mapped */ 4:
                    message.mapped = reader.int32();
                    break;
                case /* int32 unmatched_mq */ 5:
                    message.unmatchedMq = reader.int32();
                    break;
                case /* int32 unmapped_kalos */ 6:
                    message.unmappedKalos = reader.int32();
                    break;
                case /* string message */ 7:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* int64 mq_company_id = 2; */
        if (message.mqCompanyId !== 0n)
            writer.tag(2, WireType.Varint).int64(message.mqCompanyId);
        /* int32 mq_technicians = 3; */
        if (message.mqTechnicians !== 0)
            writer.tag(3, WireType.Varint).int32(message.mqTechnicians);
        /* int32 mapped = 4; */
        if (message.mapped !== 0)
            writer.tag(4, WireType.Varint).int32(message.mapped);
        /* int32 unmatched_mq = 5; */
        if (message.unmatchedMq !== 0)
            writer.tag(5, WireType.Varint).int32(message.unmatchedMq);
        /* int32 unmapped_kalos = 6; */
        if (message.unmappedKalos !== 0)
            writer.tag(6, WireType.Varint).int32(message.unmappedKalos);
        /* string message = 7; */
        if (message.message !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SyncTechniciansResponse
 */
export const SyncTechniciansResponse = new SyncTechniciansResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DispatchServiceItemRequest$Type extends MessageType {
    constructor() {
        super("DispatchServiceItemRequest", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "service_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "technician_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.serviceItemId = 0;
        message.technicianUserId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* int32 service_item_id */ 2:
                    message.serviceItemId = reader.int32();
                    break;
                case /* int32 technician_user_id */ 3:
                    message.technicianUserId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* int32 service_item_id = 2; */
        if (message.serviceItemId !== 0)
            writer.tag(2, WireType.Varint).int32(message.serviceItemId);
        /* int32 technician_user_id = 3; */
        if (message.technicianUserId !== 0)
            writer.tag(3, WireType.Varint).int32(message.technicianUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DispatchServiceItemRequest
 */
export const DispatchServiceItemRequest = new DispatchServiceItemRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DispatchServiceItemResponse$Type extends MessageType {
    constructor() {
        super("DispatchServiceItemResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "reference_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        message.referenceId = "";
        message.status = "";
        message.message = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string reference_id */ 2:
                    message.referenceId = reader.string();
                    break;
                case /* string status */ 3:
                    message.status = reader.string();
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                case /* string reason */ 5:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string reference_id = 2; */
        if (message.referenceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.referenceId);
        /* string status = 3; */
        if (message.status !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.status);
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        /* string reason = 5; */
        if (message.reason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DispatchServiceItemResponse
 */
export const DispatchServiceItemResponse = new DispatchServiceItemResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MeasureQuickReadingFilter$Type extends MessageType {
    constructor() {
        super("MeasureQuickReadingFilter", [
            { no: 1, name: "service_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.serviceItemId = 0;
        message.eventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 service_item_id */ 1:
                    message.serviceItemId = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 service_item_id = 1; */
        if (message.serviceItemId !== 0)
            writer.tag(1, WireType.Varint).int32(message.serviceItemId);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MeasureQuickReadingFilter
 */
export const MeasureQuickReadingFilter = new MeasureQuickReadingFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MeasureQuickReadingList$Type extends MessageType {
    constructor() {
        super("MeasureQuickReadingList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MeasureQuickReading },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MeasureQuickReading results */ 1:
                    message.results.push(MeasureQuickReading.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MeasureQuickReading results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MeasureQuickReading.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MeasureQuickReadingList
 */
export const MeasureQuickReadingList = new MeasureQuickReadingList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MeasureQuickDispatchFilter$Type extends MessageType {
    constructor() {
        super("MeasureQuickDispatchFilter", [
            { no: 1, name: "service_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.serviceItemId = 0;
        message.eventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 service_item_id */ 1:
                    message.serviceItemId = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 service_item_id = 1; */
        if (message.serviceItemId !== 0)
            writer.tag(1, WireType.Varint).int32(message.serviceItemId);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MeasureQuickDispatchFilter
 */
export const MeasureQuickDispatchFilter = new MeasureQuickDispatchFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MeasureQuickDispatchList$Type extends MessageType {
    constructor() {
        super("MeasureQuickDispatchList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MeasureQuickDispatchState },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MeasureQuickDispatchState results */ 1:
                    message.results.push(MeasureQuickDispatchState.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MeasureQuickDispatchState results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MeasureQuickDispatchState.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MeasureQuickDispatchList
 */
export const MeasureQuickDispatchList = new MeasureQuickDispatchList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MeasureQuickDispatchState$Type extends MessageType {
    constructor() {
        super("MeasureQuickDispatchState", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "service_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reference_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mq_project_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "dispatched_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "report_pulled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "media_pulled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "equipment_synced", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.serviceItemId = 0;
        message.referenceId = "";
        message.mqProjectId = 0n;
        message.status = "";
        message.dispatchedAt = "";
        message.reportPulled = false;
        message.mediaPulled = false;
        message.equipmentSynced = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* int32 service_item_id */ 2:
                    message.serviceItemId = reader.int32();
                    break;
                case /* string reference_id */ 3:
                    message.referenceId = reader.string();
                    break;
                case /* int64 mq_project_id */ 4:
                    message.mqProjectId = reader.int64().toBigInt();
                    break;
                case /* string status */ 5:
                    message.status = reader.string();
                    break;
                case /* string dispatched_at */ 6:
                    message.dispatchedAt = reader.string();
                    break;
                case /* bool report_pulled */ 7:
                    message.reportPulled = reader.bool();
                    break;
                case /* bool media_pulled */ 8:
                    message.mediaPulled = reader.bool();
                    break;
                case /* bool equipment_synced */ 9:
                    message.equipmentSynced = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* int32 service_item_id = 2; */
        if (message.serviceItemId !== 0)
            writer.tag(2, WireType.Varint).int32(message.serviceItemId);
        /* string reference_id = 3; */
        if (message.referenceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.referenceId);
        /* int64 mq_project_id = 4; */
        if (message.mqProjectId !== 0n)
            writer.tag(4, WireType.Varint).int64(message.mqProjectId);
        /* string status = 5; */
        if (message.status !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.status);
        /* string dispatched_at = 6; */
        if (message.dispatchedAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dispatchedAt);
        /* bool report_pulled = 7; */
        if (message.reportPulled !== false)
            writer.tag(7, WireType.Varint).bool(message.reportPulled);
        /* bool media_pulled = 8; */
        if (message.mediaPulled !== false)
            writer.tag(8, WireType.Varint).bool(message.mediaPulled);
        /* bool equipment_synced = 9; */
        if (message.equipmentSynced !== false)
            writer.tag(9, WireType.Varint).bool(message.equipmentSynced);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MeasureQuickDispatchState
 */
export const MeasureQuickDispatchState = new MeasureQuickDispatchState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MeasureQuickDiagnostic$Type extends MessageType {
    constructor() {
        super("MeasureQuickDiagnostic", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "subsystem", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "verdict", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "corrective_action", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.subsystem = "";
        message.verdict = "";
        message.correctiveAction = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string subsystem */ 2:
                    message.subsystem = reader.string();
                    break;
                case /* string verdict */ 3:
                    message.verdict = reader.string();
                    break;
                case /* string corrective_action */ 4:
                    message.correctiveAction = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string subsystem = 2; */
        if (message.subsystem !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.subsystem);
        /* string verdict = 3; */
        if (message.verdict !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.verdict);
        /* string corrective_action = 4; */
        if (message.correctiveAction !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.correctiveAction);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MeasureQuickDiagnostic
 */
export const MeasureQuickDiagnostic = new MeasureQuickDiagnostic$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MeasureQuickReading$Type extends MessageType {
    constructor() {
        super("MeasureQuickReading", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "service_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "reading_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "reference_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mq_project_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "workflow_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "session_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "session_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "session_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "diagnostic_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "diagnostic_score", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "diagnostics", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MeasureQuickDiagnostic },
            { no: 15, name: "unmapped_fields", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 20, name: "suction_line_temp_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 21, name: "liquid_line_temp_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 22, name: "discharge_line_temp_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 23, name: "outdoor_air_temp_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 24, name: "superheat_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 25, name: "subcooling_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 26, name: "compression_ratio", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 27, name: "condenser_power_factor", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 28, name: "condenser_power_w", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 29, name: "return_temp_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 30, name: "return_humidity_pct", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 31, name: "return_wet_bulb_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 32, name: "supply_temp_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 33, name: "supply_humidity_pct", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 34, name: "supply_wet_bulb_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 35, name: "airflow_estimated_scfm", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 36, name: "airflow_measured_scfm", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 37, name: "total_external_static_pressure", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 38, name: "ahu_power_factor", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 39, name: "ahu_power_w", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 40, name: "system_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "nominal_tonnage", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 42, name: "refrigerant", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "nominal_airflow_scfm_per_ton", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 44, name: "seer_rating", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 45, name: "metering_device", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 46, name: "atmospheric_pressure_psia", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 47, name: "elevation_ft", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 48, name: "outdoor_temperature_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 49, name: "outdoor_humidity_pct", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 50, name: "dew_point_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 51, name: "system_stability", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 52, name: "system_benchmarked", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 53, name: "temp_split_target_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 54, name: "temp_split_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 55, name: "fan_efficacy", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 56, name: "total_power_w", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 57, name: "eer", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 58, name: "approx_seer", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 59, name: "filter_face_velocity_fpm", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 60, name: "sensible_heat_ratio", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 61, name: "low_pressure_psig", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 62, name: "low_pressure_saturation_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 63, name: "high_pressure_psig", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 64, name: "high_pressure_saturation_f", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 65, name: "condenser_voltage_l1", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 66, name: "condenser_voltage_l2", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 67, name: "condenser_voltage_l3", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 68, name: "condenser_amperage_l1", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 69, name: "condenser_amperage_l2", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 70, name: "condenser_amperage_l3", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 71, name: "ahu_voltage_l1", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 72, name: "ahu_voltage_l2", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 73, name: "ahu_voltage_l3", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 74, name: "ahu_amperage_l1", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 75, name: "ahu_amperage_l2", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 76, name: "ahu_amperage_l3", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 77, name: "capacity_nominal_tons", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 78, name: "capacity_nominal_btuh", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 79, name: "capacity_normalized_tons", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 80, name: "capacity_normalized_btuh", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 81, name: "capacity_actual_tons", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 82, name: "capacity_actual_btuh", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 83, name: "capacity_actual_normalized_pct", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 84, name: "capacity_sensible_tons", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 85, name: "capacity_sensible_btuh", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 86, name: "capacity_sensible_normalized_pct", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 87, name: "capacity_latent_tons", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 88, name: "capacity_latent_btuh", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 89, name: "capacity_latent_normalized_pct", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 90, name: "dehumidification_lb_hr", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 91, name: "dehumidification_gal_hr", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.serviceItemId = 0;
        message.eventId = 0;
        message.readingId = 0;
        message.referenceId = "";
        message.mqProjectId = 0n;
        message.workflowName = "";
        message.sessionLabel = "";
        message.sessionType = "";
        message.sessionAt = "";
        message.notes = "";
        message.diagnosticMessage = "";
        message.diagnosticScore = 0;
        message.diagnostics = [];
        message.unmappedFields = {};
        message.systemType = "";
        message.refrigerant = "";
        message.seerRating = "";
        message.meteringDevice = "";
        message.systemStability = "";
        message.systemBenchmarked = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 service_item_id */ 2:
                    message.serviceItemId = reader.int32();
                    break;
                case /* int32 event_id */ 3:
                    message.eventId = reader.int32();
                    break;
                case /* int32 reading_id */ 4:
                    message.readingId = reader.int32();
                    break;
                case /* string reference_id */ 5:
                    message.referenceId = reader.string();
                    break;
                case /* int64 mq_project_id */ 6:
                    message.mqProjectId = reader.int64().toBigInt();
                    break;
                case /* string workflow_name */ 7:
                    message.workflowName = reader.string();
                    break;
                case /* string session_label */ 8:
                    message.sessionLabel = reader.string();
                    break;
                case /* string session_type */ 9:
                    message.sessionType = reader.string();
                    break;
                case /* string session_at */ 10:
                    message.sessionAt = reader.string();
                    break;
                case /* string notes */ 11:
                    message.notes = reader.string();
                    break;
                case /* string diagnostic_message */ 12:
                    message.diagnosticMessage = reader.string();
                    break;
                case /* int32 diagnostic_score */ 13:
                    message.diagnosticScore = reader.int32();
                    break;
                case /* repeated MeasureQuickDiagnostic diagnostics */ 14:
                    message.diagnostics.push(MeasureQuickDiagnostic.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, string> unmapped_fields */ 15:
                    this.binaryReadMap15(message.unmappedFields, reader, options);
                    break;
                case /* optional double suction_line_temp_f */ 20:
                    message.suctionLineTempF = reader.double();
                    break;
                case /* optional double liquid_line_temp_f */ 21:
                    message.liquidLineTempF = reader.double();
                    break;
                case /* optional double discharge_line_temp_f */ 22:
                    message.dischargeLineTempF = reader.double();
                    break;
                case /* optional double outdoor_air_temp_f */ 23:
                    message.outdoorAirTempF = reader.double();
                    break;
                case /* optional double superheat_f */ 24:
                    message.superheatF = reader.double();
                    break;
                case /* optional double subcooling_f */ 25:
                    message.subcoolingF = reader.double();
                    break;
                case /* optional double compression_ratio */ 26:
                    message.compressionRatio = reader.double();
                    break;
                case /* optional double condenser_power_factor */ 27:
                    message.condenserPowerFactor = reader.double();
                    break;
                case /* optional double condenser_power_w */ 28:
                    message.condenserPowerW = reader.double();
                    break;
                case /* optional double return_temp_f */ 29:
                    message.returnTempF = reader.double();
                    break;
                case /* optional double return_humidity_pct */ 30:
                    message.returnHumidityPct = reader.double();
                    break;
                case /* optional double return_wet_bulb_f */ 31:
                    message.returnWetBulbF = reader.double();
                    break;
                case /* optional double supply_temp_f */ 32:
                    message.supplyTempF = reader.double();
                    break;
                case /* optional double supply_humidity_pct */ 33:
                    message.supplyHumidityPct = reader.double();
                    break;
                case /* optional double supply_wet_bulb_f */ 34:
                    message.supplyWetBulbF = reader.double();
                    break;
                case /* optional double airflow_estimated_scfm */ 35:
                    message.airflowEstimatedScfm = reader.double();
                    break;
                case /* optional double airflow_measured_scfm */ 36:
                    message.airflowMeasuredScfm = reader.double();
                    break;
                case /* optional double total_external_static_pressure */ 37:
                    message.totalExternalStaticPressure = reader.double();
                    break;
                case /* optional double ahu_power_factor */ 38:
                    message.ahuPowerFactor = reader.double();
                    break;
                case /* optional double ahu_power_w */ 39:
                    message.ahuPowerW = reader.double();
                    break;
                case /* string system_type */ 40:
                    message.systemType = reader.string();
                    break;
                case /* optional double nominal_tonnage */ 41:
                    message.nominalTonnage = reader.double();
                    break;
                case /* string refrigerant */ 42:
                    message.refrigerant = reader.string();
                    break;
                case /* optional double nominal_airflow_scfm_per_ton */ 43:
                    message.nominalAirflowScfmPerTon = reader.double();
                    break;
                case /* string seer_rating */ 44:
                    message.seerRating = reader.string();
                    break;
                case /* string metering_device */ 45:
                    message.meteringDevice = reader.string();
                    break;
                case /* optional double atmospheric_pressure_psia */ 46:
                    message.atmosphericPressurePsia = reader.double();
                    break;
                case /* optional double elevation_ft */ 47:
                    message.elevationFt = reader.double();
                    break;
                case /* optional double outdoor_temperature_f */ 48:
                    message.outdoorTemperatureF = reader.double();
                    break;
                case /* optional double outdoor_humidity_pct */ 49:
                    message.outdoorHumidityPct = reader.double();
                    break;
                case /* optional double dew_point_f */ 50:
                    message.dewPointF = reader.double();
                    break;
                case /* string system_stability */ 51:
                    message.systemStability = reader.string();
                    break;
                case /* string system_benchmarked */ 52:
                    message.systemBenchmarked = reader.string();
                    break;
                case /* optional double temp_split_target_f */ 53:
                    message.tempSplitTargetF = reader.double();
                    break;
                case /* optional double temp_split_f */ 54:
                    message.tempSplitF = reader.double();
                    break;
                case /* optional double fan_efficacy */ 55:
                    message.fanEfficacy = reader.double();
                    break;
                case /* optional double total_power_w */ 56:
                    message.totalPowerW = reader.double();
                    break;
                case /* optional double eer */ 57:
                    message.eer = reader.double();
                    break;
                case /* optional double approx_seer */ 58:
                    message.approxSeer = reader.double();
                    break;
                case /* optional double filter_face_velocity_fpm */ 59:
                    message.filterFaceVelocityFpm = reader.double();
                    break;
                case /* optional double sensible_heat_ratio */ 60:
                    message.sensibleHeatRatio = reader.double();
                    break;
                case /* optional double low_pressure_psig */ 61:
                    message.lowPressurePsig = reader.double();
                    break;
                case /* optional double low_pressure_saturation_f */ 62:
                    message.lowPressureSaturationF = reader.double();
                    break;
                case /* optional double high_pressure_psig */ 63:
                    message.highPressurePsig = reader.double();
                    break;
                case /* optional double high_pressure_saturation_f */ 64:
                    message.highPressureSaturationF = reader.double();
                    break;
                case /* optional double condenser_voltage_l1 */ 65:
                    message.condenserVoltageL1 = reader.double();
                    break;
                case /* optional double condenser_voltage_l2 */ 66:
                    message.condenserVoltageL2 = reader.double();
                    break;
                case /* optional double condenser_voltage_l3 */ 67:
                    message.condenserVoltageL3 = reader.double();
                    break;
                case /* optional double condenser_amperage_l1 */ 68:
                    message.condenserAmperageL1 = reader.double();
                    break;
                case /* optional double condenser_amperage_l2 */ 69:
                    message.condenserAmperageL2 = reader.double();
                    break;
                case /* optional double condenser_amperage_l3 */ 70:
                    message.condenserAmperageL3 = reader.double();
                    break;
                case /* optional double ahu_voltage_l1 */ 71:
                    message.ahuVoltageL1 = reader.double();
                    break;
                case /* optional double ahu_voltage_l2 */ 72:
                    message.ahuVoltageL2 = reader.double();
                    break;
                case /* optional double ahu_voltage_l3 */ 73:
                    message.ahuVoltageL3 = reader.double();
                    break;
                case /* optional double ahu_amperage_l1 */ 74:
                    message.ahuAmperageL1 = reader.double();
                    break;
                case /* optional double ahu_amperage_l2 */ 75:
                    message.ahuAmperageL2 = reader.double();
                    break;
                case /* optional double ahu_amperage_l3 */ 76:
                    message.ahuAmperageL3 = reader.double();
                    break;
                case /* optional double capacity_nominal_tons */ 77:
                    message.capacityNominalTons = reader.double();
                    break;
                case /* optional double capacity_nominal_btuh */ 78:
                    message.capacityNominalBtuh = reader.double();
                    break;
                case /* optional double capacity_normalized_tons */ 79:
                    message.capacityNormalizedTons = reader.double();
                    break;
                case /* optional double capacity_normalized_btuh */ 80:
                    message.capacityNormalizedBtuh = reader.double();
                    break;
                case /* optional double capacity_actual_tons */ 81:
                    message.capacityActualTons = reader.double();
                    break;
                case /* optional double capacity_actual_btuh */ 82:
                    message.capacityActualBtuh = reader.double();
                    break;
                case /* optional double capacity_actual_normalized_pct */ 83:
                    message.capacityActualNormalizedPct = reader.double();
                    break;
                case /* optional double capacity_sensible_tons */ 84:
                    message.capacitySensibleTons = reader.double();
                    break;
                case /* optional double capacity_sensible_btuh */ 85:
                    message.capacitySensibleBtuh = reader.double();
                    break;
                case /* optional double capacity_sensible_normalized_pct */ 86:
                    message.capacitySensibleNormalizedPct = reader.double();
                    break;
                case /* optional double capacity_latent_tons */ 87:
                    message.capacityLatentTons = reader.double();
                    break;
                case /* optional double capacity_latent_btuh */ 88:
                    message.capacityLatentBtuh = reader.double();
                    break;
                case /* optional double capacity_latent_normalized_pct */ 89:
                    message.capacityLatentNormalizedPct = reader.double();
                    break;
                case /* optional double dehumidification_lb_hr */ 90:
                    message.dehumidificationLbHr = reader.double();
                    break;
                case /* optional double dehumidification_gal_hr */ 91:
                    message.dehumidificationGalHr = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap15(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for MeasureQuickReading.unmapped_fields");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 service_item_id = 2; */
        if (message.serviceItemId !== 0)
            writer.tag(2, WireType.Varint).int32(message.serviceItemId);
        /* int32 event_id = 3; */
        if (message.eventId !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventId);
        /* int32 reading_id = 4; */
        if (message.readingId !== 0)
            writer.tag(4, WireType.Varint).int32(message.readingId);
        /* string reference_id = 5; */
        if (message.referenceId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.referenceId);
        /* int64 mq_project_id = 6; */
        if (message.mqProjectId !== 0n)
            writer.tag(6, WireType.Varint).int64(message.mqProjectId);
        /* string workflow_name = 7; */
        if (message.workflowName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.workflowName);
        /* string session_label = 8; */
        if (message.sessionLabel !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.sessionLabel);
        /* string session_type = 9; */
        if (message.sessionType !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.sessionType);
        /* string session_at = 10; */
        if (message.sessionAt !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.sessionAt);
        /* string notes = 11; */
        if (message.notes !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.notes);
        /* string diagnostic_message = 12; */
        if (message.diagnosticMessage !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.diagnosticMessage);
        /* int32 diagnostic_score = 13; */
        if (message.diagnosticScore !== 0)
            writer.tag(13, WireType.Varint).int32(message.diagnosticScore);
        /* repeated MeasureQuickDiagnostic diagnostics = 14; */
        for (let i = 0; i < message.diagnostics.length; i++)
            MeasureQuickDiagnostic.internalBinaryWrite(message.diagnostics[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> unmapped_fields = 15; */
        for (let k of globalThis.Object.keys(message.unmappedFields))
            writer.tag(15, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.unmappedFields[k]).join();
        /* optional double suction_line_temp_f = 20; */
        if (message.suctionLineTempF !== undefined)
            writer.tag(20, WireType.Bit64).double(message.suctionLineTempF);
        /* optional double liquid_line_temp_f = 21; */
        if (message.liquidLineTempF !== undefined)
            writer.tag(21, WireType.Bit64).double(message.liquidLineTempF);
        /* optional double discharge_line_temp_f = 22; */
        if (message.dischargeLineTempF !== undefined)
            writer.tag(22, WireType.Bit64).double(message.dischargeLineTempF);
        /* optional double outdoor_air_temp_f = 23; */
        if (message.outdoorAirTempF !== undefined)
            writer.tag(23, WireType.Bit64).double(message.outdoorAirTempF);
        /* optional double superheat_f = 24; */
        if (message.superheatF !== undefined)
            writer.tag(24, WireType.Bit64).double(message.superheatF);
        /* optional double subcooling_f = 25; */
        if (message.subcoolingF !== undefined)
            writer.tag(25, WireType.Bit64).double(message.subcoolingF);
        /* optional double compression_ratio = 26; */
        if (message.compressionRatio !== undefined)
            writer.tag(26, WireType.Bit64).double(message.compressionRatio);
        /* optional double condenser_power_factor = 27; */
        if (message.condenserPowerFactor !== undefined)
            writer.tag(27, WireType.Bit64).double(message.condenserPowerFactor);
        /* optional double condenser_power_w = 28; */
        if (message.condenserPowerW !== undefined)
            writer.tag(28, WireType.Bit64).double(message.condenserPowerW);
        /* optional double return_temp_f = 29; */
        if (message.returnTempF !== undefined)
            writer.tag(29, WireType.Bit64).double(message.returnTempF);
        /* optional double return_humidity_pct = 30; */
        if (message.returnHumidityPct !== undefined)
            writer.tag(30, WireType.Bit64).double(message.returnHumidityPct);
        /* optional double return_wet_bulb_f = 31; */
        if (message.returnWetBulbF !== undefined)
            writer.tag(31, WireType.Bit64).double(message.returnWetBulbF);
        /* optional double supply_temp_f = 32; */
        if (message.supplyTempF !== undefined)
            writer.tag(32, WireType.Bit64).double(message.supplyTempF);
        /* optional double supply_humidity_pct = 33; */
        if (message.supplyHumidityPct !== undefined)
            writer.tag(33, WireType.Bit64).double(message.supplyHumidityPct);
        /* optional double supply_wet_bulb_f = 34; */
        if (message.supplyWetBulbF !== undefined)
            writer.tag(34, WireType.Bit64).double(message.supplyWetBulbF);
        /* optional double airflow_estimated_scfm = 35; */
        if (message.airflowEstimatedScfm !== undefined)
            writer.tag(35, WireType.Bit64).double(message.airflowEstimatedScfm);
        /* optional double airflow_measured_scfm = 36; */
        if (message.airflowMeasuredScfm !== undefined)
            writer.tag(36, WireType.Bit64).double(message.airflowMeasuredScfm);
        /* optional double total_external_static_pressure = 37; */
        if (message.totalExternalStaticPressure !== undefined)
            writer.tag(37, WireType.Bit64).double(message.totalExternalStaticPressure);
        /* optional double ahu_power_factor = 38; */
        if (message.ahuPowerFactor !== undefined)
            writer.tag(38, WireType.Bit64).double(message.ahuPowerFactor);
        /* optional double ahu_power_w = 39; */
        if (message.ahuPowerW !== undefined)
            writer.tag(39, WireType.Bit64).double(message.ahuPowerW);
        /* string system_type = 40; */
        if (message.systemType !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.systemType);
        /* optional double nominal_tonnage = 41; */
        if (message.nominalTonnage !== undefined)
            writer.tag(41, WireType.Bit64).double(message.nominalTonnage);
        /* string refrigerant = 42; */
        if (message.refrigerant !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.refrigerant);
        /* optional double nominal_airflow_scfm_per_ton = 43; */
        if (message.nominalAirflowScfmPerTon !== undefined)
            writer.tag(43, WireType.Bit64).double(message.nominalAirflowScfmPerTon);
        /* string seer_rating = 44; */
        if (message.seerRating !== "")
            writer.tag(44, WireType.LengthDelimited).string(message.seerRating);
        /* string metering_device = 45; */
        if (message.meteringDevice !== "")
            writer.tag(45, WireType.LengthDelimited).string(message.meteringDevice);
        /* optional double atmospheric_pressure_psia = 46; */
        if (message.atmosphericPressurePsia !== undefined)
            writer.tag(46, WireType.Bit64).double(message.atmosphericPressurePsia);
        /* optional double elevation_ft = 47; */
        if (message.elevationFt !== undefined)
            writer.tag(47, WireType.Bit64).double(message.elevationFt);
        /* optional double outdoor_temperature_f = 48; */
        if (message.outdoorTemperatureF !== undefined)
            writer.tag(48, WireType.Bit64).double(message.outdoorTemperatureF);
        /* optional double outdoor_humidity_pct = 49; */
        if (message.outdoorHumidityPct !== undefined)
            writer.tag(49, WireType.Bit64).double(message.outdoorHumidityPct);
        /* optional double dew_point_f = 50; */
        if (message.dewPointF !== undefined)
            writer.tag(50, WireType.Bit64).double(message.dewPointF);
        /* string system_stability = 51; */
        if (message.systemStability !== "")
            writer.tag(51, WireType.LengthDelimited).string(message.systemStability);
        /* string system_benchmarked = 52; */
        if (message.systemBenchmarked !== "")
            writer.tag(52, WireType.LengthDelimited).string(message.systemBenchmarked);
        /* optional double temp_split_target_f = 53; */
        if (message.tempSplitTargetF !== undefined)
            writer.tag(53, WireType.Bit64).double(message.tempSplitTargetF);
        /* optional double temp_split_f = 54; */
        if (message.tempSplitF !== undefined)
            writer.tag(54, WireType.Bit64).double(message.tempSplitF);
        /* optional double fan_efficacy = 55; */
        if (message.fanEfficacy !== undefined)
            writer.tag(55, WireType.Bit64).double(message.fanEfficacy);
        /* optional double total_power_w = 56; */
        if (message.totalPowerW !== undefined)
            writer.tag(56, WireType.Bit64).double(message.totalPowerW);
        /* optional double eer = 57; */
        if (message.eer !== undefined)
            writer.tag(57, WireType.Bit64).double(message.eer);
        /* optional double approx_seer = 58; */
        if (message.approxSeer !== undefined)
            writer.tag(58, WireType.Bit64).double(message.approxSeer);
        /* optional double filter_face_velocity_fpm = 59; */
        if (message.filterFaceVelocityFpm !== undefined)
            writer.tag(59, WireType.Bit64).double(message.filterFaceVelocityFpm);
        /* optional double sensible_heat_ratio = 60; */
        if (message.sensibleHeatRatio !== undefined)
            writer.tag(60, WireType.Bit64).double(message.sensibleHeatRatio);
        /* optional double low_pressure_psig = 61; */
        if (message.lowPressurePsig !== undefined)
            writer.tag(61, WireType.Bit64).double(message.lowPressurePsig);
        /* optional double low_pressure_saturation_f = 62; */
        if (message.lowPressureSaturationF !== undefined)
            writer.tag(62, WireType.Bit64).double(message.lowPressureSaturationF);
        /* optional double high_pressure_psig = 63; */
        if (message.highPressurePsig !== undefined)
            writer.tag(63, WireType.Bit64).double(message.highPressurePsig);
        /* optional double high_pressure_saturation_f = 64; */
        if (message.highPressureSaturationF !== undefined)
            writer.tag(64, WireType.Bit64).double(message.highPressureSaturationF);
        /* optional double condenser_voltage_l1 = 65; */
        if (message.condenserVoltageL1 !== undefined)
            writer.tag(65, WireType.Bit64).double(message.condenserVoltageL1);
        /* optional double condenser_voltage_l2 = 66; */
        if (message.condenserVoltageL2 !== undefined)
            writer.tag(66, WireType.Bit64).double(message.condenserVoltageL2);
        /* optional double condenser_voltage_l3 = 67; */
        if (message.condenserVoltageL3 !== undefined)
            writer.tag(67, WireType.Bit64).double(message.condenserVoltageL3);
        /* optional double condenser_amperage_l1 = 68; */
        if (message.condenserAmperageL1 !== undefined)
            writer.tag(68, WireType.Bit64).double(message.condenserAmperageL1);
        /* optional double condenser_amperage_l2 = 69; */
        if (message.condenserAmperageL2 !== undefined)
            writer.tag(69, WireType.Bit64).double(message.condenserAmperageL2);
        /* optional double condenser_amperage_l3 = 70; */
        if (message.condenserAmperageL3 !== undefined)
            writer.tag(70, WireType.Bit64).double(message.condenserAmperageL3);
        /* optional double ahu_voltage_l1 = 71; */
        if (message.ahuVoltageL1 !== undefined)
            writer.tag(71, WireType.Bit64).double(message.ahuVoltageL1);
        /* optional double ahu_voltage_l2 = 72; */
        if (message.ahuVoltageL2 !== undefined)
            writer.tag(72, WireType.Bit64).double(message.ahuVoltageL2);
        /* optional double ahu_voltage_l3 = 73; */
        if (message.ahuVoltageL3 !== undefined)
            writer.tag(73, WireType.Bit64).double(message.ahuVoltageL3);
        /* optional double ahu_amperage_l1 = 74; */
        if (message.ahuAmperageL1 !== undefined)
            writer.tag(74, WireType.Bit64).double(message.ahuAmperageL1);
        /* optional double ahu_amperage_l2 = 75; */
        if (message.ahuAmperageL2 !== undefined)
            writer.tag(75, WireType.Bit64).double(message.ahuAmperageL2);
        /* optional double ahu_amperage_l3 = 76; */
        if (message.ahuAmperageL3 !== undefined)
            writer.tag(76, WireType.Bit64).double(message.ahuAmperageL3);
        /* optional double capacity_nominal_tons = 77; */
        if (message.capacityNominalTons !== undefined)
            writer.tag(77, WireType.Bit64).double(message.capacityNominalTons);
        /* optional double capacity_nominal_btuh = 78; */
        if (message.capacityNominalBtuh !== undefined)
            writer.tag(78, WireType.Bit64).double(message.capacityNominalBtuh);
        /* optional double capacity_normalized_tons = 79; */
        if (message.capacityNormalizedTons !== undefined)
            writer.tag(79, WireType.Bit64).double(message.capacityNormalizedTons);
        /* optional double capacity_normalized_btuh = 80; */
        if (message.capacityNormalizedBtuh !== undefined)
            writer.tag(80, WireType.Bit64).double(message.capacityNormalizedBtuh);
        /* optional double capacity_actual_tons = 81; */
        if (message.capacityActualTons !== undefined)
            writer.tag(81, WireType.Bit64).double(message.capacityActualTons);
        /* optional double capacity_actual_btuh = 82; */
        if (message.capacityActualBtuh !== undefined)
            writer.tag(82, WireType.Bit64).double(message.capacityActualBtuh);
        /* optional double capacity_actual_normalized_pct = 83; */
        if (message.capacityActualNormalizedPct !== undefined)
            writer.tag(83, WireType.Bit64).double(message.capacityActualNormalizedPct);
        /* optional double capacity_sensible_tons = 84; */
        if (message.capacitySensibleTons !== undefined)
            writer.tag(84, WireType.Bit64).double(message.capacitySensibleTons);
        /* optional double capacity_sensible_btuh = 85; */
        if (message.capacitySensibleBtuh !== undefined)
            writer.tag(85, WireType.Bit64).double(message.capacitySensibleBtuh);
        /* optional double capacity_sensible_normalized_pct = 86; */
        if (message.capacitySensibleNormalizedPct !== undefined)
            writer.tag(86, WireType.Bit64).double(message.capacitySensibleNormalizedPct);
        /* optional double capacity_latent_tons = 87; */
        if (message.capacityLatentTons !== undefined)
            writer.tag(87, WireType.Bit64).double(message.capacityLatentTons);
        /* optional double capacity_latent_btuh = 88; */
        if (message.capacityLatentBtuh !== undefined)
            writer.tag(88, WireType.Bit64).double(message.capacityLatentBtuh);
        /* optional double capacity_latent_normalized_pct = 89; */
        if (message.capacityLatentNormalizedPct !== undefined)
            writer.tag(89, WireType.Bit64).double(message.capacityLatentNormalizedPct);
        /* optional double dehumidification_lb_hr = 90; */
        if (message.dehumidificationLbHr !== undefined)
            writer.tag(90, WireType.Bit64).double(message.dehumidificationLbHr);
        /* optional double dehumidification_gal_hr = 91; */
        if (message.dehumidificationGalHr !== undefined)
            writer.tag(91, WireType.Bit64).double(message.dehumidificationGalHr);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MeasureQuickReading
 */
export const MeasureQuickReading = new MeasureQuickReading$Type();
/**
 * @generated ServiceType for protobuf service MeasureQuickService
 */
export const MeasureQuickService = new ServiceType("MeasureQuickService", [
    { name: "GetHealthStatus", options: {}, I: GetHealthStatusRequest, O: GetHealthStatusResponse },
    { name: "SyncTechnicians", options: {}, I: SyncTechniciansRequest, O: SyncTechniciansResponse },
    { name: "DispatchServiceItem", options: {}, I: DispatchServiceItemRequest, O: DispatchServiceItemResponse },
    { name: "BatchGetMeasureQuickReadings", options: {}, I: MeasureQuickReadingFilter, O: MeasureQuickReadingList },
    { name: "BatchGetMeasureQuickDispatches", options: {}, I: MeasureQuickDispatchFilter, O: MeasureQuickDispatchList }
]);
